// URL d'affichage d'une image Google Drive publique via le CDN Google (lh3.googleusercontent.com).
// Plus fiable que https://drive.google.com/thumbnail?id=… qui est souvent bloqué (localhost, hotlink).
// Le fichier doit être partagé publiquement (les avatars staff le sont via shareFileToPublic côté back).
export const driveImageUrl = (googleDriveId?: string | null): string =>
     googleDriveId ? `https://lh3.googleusercontent.com/d/${googleDriveId}` : ""
